/* eslint-disable no-param-reassign */
import { components } from "react-select";
import PropTypes from "prop-types";

const MultiValueContainer = ({ className, preserveStyle, children, ...otherProps }) => {
  if (!preserveStyle) {
    // So that the default styles aren't applied, for full customization
    otherProps.getStyles = () => ({});
  }

  return (
    <components.MultiValueContainer {...otherProps} className={className}>
      {children}
    </components.MultiValueContainer>
  );
};

MultiValueContainer.propTypes = {
  className: PropTypes.string,
  preserveStyle: PropTypes.bool,
  children: PropTypes.node,
};

MultiValueContainer.defaultProps = {
  className: "",
  preserveStyle: false,
  children: null,
};

export default MultiValueContainer;
